require('./ctxGrid.style.scss');
const dependencies = ['$scope', '$element', '$transclude', '$timeout', '$document', '$attrs'];
const CLICK_DELAY = 200;
class GridController {
    constructor() {
        require('../utils/injectDeps')(this, arguments);
        this.columns = [];
        this.hasHeaderRow = false;
        this.hasFooterRow = false;
        this.$element.addClass('ctx-grid');
        this.clickable = typeof this.clickable === 'undefined' ? true : this.clickable;
        this.idKey = this.idKey || 'uuid';
        this.$document.keyup((e) => {
            if (this.$document.find('.modal-backdrop').length) return;
            if (e.keyCode === 27) {
                this.clearAll();
                this.openDetails({ index: 0, item: {} });
            }
        });
    }
    $onInit() {
        this.onCustomScrollUpdate = false;
        this.$transclude(
            this.$scope,
            (clone) => {
                this.$element.append(clone);
                this.$timeout(() => {
                    clone.remove.bind(clone);
                });
            },
            this.$element
        );
        this.onInit && this.onInit({ $event: { grid: this } });
        this.$scope.$watch(
            () => this.reselectFlag,
            () => {
                if (!this.reselectFlag) return;
                this.perPageSelected = this.selectedItems.slice();
            }
        );
        this.$scope.$watchCollection(
            () => this.selectedItems,
            (selectedItems) => {
                this.markSelected(this.items || [], selectedItems || []);
            }
        );
        this.$scope.$watchCollection(
            () => this.items,
            (items) => {
                this.eventTargetEl = null;
                this.markSelected(items || [], this.selectedItems || []);
            }
        );
        // FOR MULTISELECT
        if (this.multiSelect) {
            // IF ALL ITEMS ARE DEFINED:
            // HANDLE DISPLAY SELECTION DEPENDING ON ALL AVAILABLE ITEMS
            // NUMBER OF AVAILABLE ITEMS DEPENDS OF APPLIED FILTER/SEARCH CRITERIA
            this.$scope.$watchCollection(
                () => this.allItems,
                () => {
                    if (!this.allItems) return;
                    if (!this.allItems.length || !this.perPageSelected || !this.perPageSelected.length) {
                        this.selectedItems = [];
                        return;
                    }
                    this.perPageSelected = this.selectedItems.slice();
                    let perPageSelectedUuids = this.perPageSelected.map((i) => i.uuid),
                        availableSelected = this.allItems.filter((i) => perPageSelectedUuids.indexOf(i.uuid) > -1),
                        currentSelection = [];
                    availableSelected.forEach((availableItem) => {
                        this.perPageSelected.forEach((selectedItem, index) => {
                            if (selectedItem.uuid !== availableItem.uuid) {
                                return;
                            }
                            availableItem._selected = true;
                            this.perPageSelected[index] = availableItem;
                            currentSelection.push(availableItem);
                        });
                    });
                    this.selectedItems = currentSelection;
                }
            );
            // IF ALL ITEMS ARE NOT DEFINED
            // HANDLE DISPLAY SELECTION DEPENDING ON FILTER BY AND SEARCH BY OPTIONS
            if (!angular.isDefined(this.allItems)) {
                // FILTER BY CHANGED
                this.$scope.$watch(
                    () => this.filters,
                    (filters) => {
                        if (filters && filters.length > 0) {
                            this.selectedItems = this.filterSelectedItems();
                        } else if (this.searchBy && this.searchKey) {
                            this.selectedItems = this.filterSelectedItems();
                        } else if (!this.skipPerPage) {
                            this.selectedItems = this.perPageSelected;
                        }
                    }
                );
                // SEARCH BY CHANGED (searchKey must be external defined otherwise won't be handle)
                this.$scope.$watch(
                    () => this.searchBy,
                    (searchBy) => {
                        if (!this.searchKey) return;
                        if (searchBy) {
                            this.selectedItems = this.filterSelectedItems();
                        } else if (this.filters && this.filters.length > 0) {
                            this.selectedItems = this.filterSelectedItems();
                        } else if (!this.skipPerPage) {
                            this.selectedItems = this.perPageSelected;
                        }
                    }
                );
            }
        }
        this.$timeout(() => {
            this.tableWidth = this.$element.find('.table').width();
            this.$scope.$watch(
                () => this.$element.find('.table').width(),
                (width) => {
                    this.tableWidth = width;
                }
            );
        }, 0);
        this.$scope.$watch(
            () => this.$attrs,
            () => {
                if (!this.$attrs) return;
                this.isResizable =
                    angular.isDefined(this.$attrs.columnsResizable) && this.$attrs.columnsResizable == '';
                this.tableName = this.$attrs.tableName;
                this.eventIdName = this.$attrs.eventIdName;
                this.tableId = this.eventIdName || this.guid();
            }
        );
        this.$element.css({ overflow: 'hidden' });
        if (this.initialSortKey) this.sortCol = this.initialSortKey;
        this.perPageSelected = [];
    }
    markSelected(items, selectedItems) {
        /** NOTE: Items that have property excluded(true) cannot be selected */
        (items || []).forEach((i) => {
            i._selected = !!(selectedItems || []).filter((si) => si[this.idKey] === i[this.idKey]).length;
            if (angular.isUndefined(i._excludedPreview)) {
                i._excludedPreview = false;
            }
        });
        this.selectionStatusClass = this.selectionStatus(this.items, this.selectedItems);
    }
    singleSelect(index, item, event) {
        if (!item.isChild) {
            this.toggleSelected(index, item, event);
        }
    }
    toggleSelected(index, item, event) {
        let showDetail = !this.multiSelect,
            shouldScroll;
        if (!this.multiSelect) {
            this.selectedItems = item._selected || item.excluded ? [] : [item];
            this.perPageSelected = item._selected || item.excluded ? [] : [item];
            shouldScroll = this.selectedItems.length > 0;
        } else {
            if (event.shiftKey) {
                if (item._selected) return;
                this.toggleShiftSelected(index, item);
            } else {
                showDetail = true;
                if (event.ctrlKey || event.metaKey || this.multiSelectOnItem) {
                    this.addSelection(index, item, false);
                } else {
                    let tempExcludedSelected = this.selectedItems.filter((i) => i.excludedSelected);
                    let tempPageExcludedSelected = this.perPageSelected.filter((i) => i.excludedSelected);
                    let tempItemList = item && !item.excluded && !item.excludedSelected ? [item] : [];
                    if (this.autoChildSelection && tempItemList.length && item.childItems) {
                        tempItemList.push(...item.childItems);
                    }
                    this.selectedItems = (tempExcludedSelected || []).concat(tempItemList);
                    this.perPageSelected = (tempPageExcludedSelected || []).concat(tempItemList);
                }
                shouldScroll = true;
                delete this.startElem;
            }
            let excludedItems = this.items.filter((item) => item._excludedPreview);
            if (excludedItems.length > 0) {
                excludedItems.forEach((ei) => (ei._excludedPreview = false));
            }
        }
        if (showDetail) this.openDetails({ index, item }, shouldScroll ? event : null);
        else this.openDetails({});
    }
    toggleShiftSelected(index, item) {
        // for shift to work, last clicked list element has to be on current side, otherwise it is treated as normal select
        if (!this.selectedItems || !this.selectedItems.length) {
            this.selectedItems = item && (!item.excluded || item.excludedSelected) ? [item] : [];
        } else {
            this.startElem = this.startElem || this.selectedItems[this.selectedItems.length - 1];
            if (!this.items.filter((si) => si.uuid === this.startElem.uuid).length) {
                let tempExcludedSelected = this.selectedItems.filter((i) => i.excludedSelected);
                let tempPageExcludedSelected = this.perPageSelected.filter((i) => i.excludedSelected);
                this.selectedItems = (tempExcludedSelected || []).concat(
                    item && !item.excluded && !item.excludedSelected ? [item] : []
                );
                this.perPageSelected = (tempPageExcludedSelected || []).concat(
                    item && !item.excluded && !item.excludedSelected ? [item] : []
                );
                delete this.startElem;
            } else {
                this.clearAllOnPage();
                let found = false;
                this.items.forEach((elem) => {
                    if (elem.uuid === this.startElem.uuid || elem.uuid === item.uuid) {
                        found = !found;
                        this.addSelection(index, elem, false);
                    } else if (found) {
                        this.addSelection(index, elem, false);
                    }
                });
            }
        }
    }
    openDetails(arg, event) {
        if (this.onDetailsAction) {
            this.$timeout(() => {
                this.onDetailsAction(arg);
                this.scrollTo(event);
            }, 0);
        }
    }
    addSelection(index, item, details, onCheckEvent) {
        if (item.isChild || item.excluded) return;
        if (onCheckEvent && onCheckEvent.shiftKey && !item._selected) {
            this.toggleShiftSelected(index, item);
        } else {
            if (this.startElem && onCheckEvent) delete this.startElem;
            this.selectedItems = item._selected
                ? this.selectedItems.filter((elem) => elem.uuid !== item.uuid || elem.excludedSelected)
                : (this.selectedItems || []).concat([item]);
            this.perPageSelected = item._selected
                ? this.perPageSelected.filter((elem) => elem.uuid !== item.uuid || elem.excludedSelected)
                : (this.perPageSelected || []).concat([item]);
        }
        if (item.childItems && item.isParent && (onCheckEvent || this.autoChildSelection)) {
            if (!item._selected) {
                this.selectedItems.push(...item.childItems);
            } else {
                item.childItems.forEach((item) => {
                    this.selectedItems = this.selectedItems.filter((i) => i.uuid !== item.uuid);
                });
            }
        }
        if (details && item._selected && !onCheckEvent) {
            this.openDetails({ index, item });
        }
        if (onCheckEvent) {
            this.openDetails({});
        }
    }
    toggleSelection(event) {
        let withCtrlClick = false;
        if (this.allItems && event && event.originalEvent && event.originalEvent.ctrlKey) {
            withCtrlClick = true;
        }
        if (this.isSelectionEmpty(withCtrlClick)) {
            this.selectAll(withCtrlClick);
        } else {
            this.clearAllOnPage(withCtrlClick);
            this.openDetails({ index: 0, item: {} });
        }
    }
    // without CTRL click: check all ITEMS on the current page
    // with CTRL click: check all available ITEMS on all pages (the number of all items depends on whether some filters or search have been applied or not)
    isSelectionEmpty(withCtrlClick) {
        let availableItems = this[withCtrlClick ? 'allItems' : 'items'].map((item) => item.uuid);
        return (
            !this.selectedItems ||
            !this.selectedItems.filter(
                (selectedItem) => !selectedItem.excludedSelected && availableItems.indexOf(selectedItem.uuid) > -1
            ).length
        );
    }
    selectAll(withCtrlClick) {
        let temp = [];
        // OPTION 1:
        // NO ITEM HAS BEEN SELECTED
        if ((this.selectedItems || []).length === 0) {
            // CASE 1 (with CTRL click):
            // SELECT ALL AVAILABLE ITEMS ON ALL PAGES (number of items and pages depends weather some filters have been applied or not)
            if (withCtrlClick) {
                if (this.skipPerPage) return;
                let availableItems = this.allItems.filter((i) => !i.excluded).slice(),
                    expandedChildOnCurrentPage = this.items
                        .filter((i) => !i.excluded && (i.isChild || i.childJob))
                        .slice();
                expandedChildOnCurrentPage.forEach((child) => availableItems.push(child));
                if ((this.perPageSelected || []).length === 0) {
                    this.perPageSelected = availableItems.filter((i) => !i.excluded).slice();
                } else {
                    this.perPageSelected.push(...availableItems.filter((i) => !i.excluded).slice());
                }
                this.selectedItems = availableItems.filter((i) => !i.excluded).slice();
            }
            // CASE 2 (without CTRL click):
            // SELECT ALL ITEMS ON THE CURRENT PAGE
            else {
                if ((this.perPageSelected || []).length === 0) {
                    this.perPageSelected = this.items.filter((i) => !i.excluded).slice();
                } else {
                    this.perPageSelected.push(...this.items.filter((i) => !i.excluded).slice());
                }
                this.selectedItems = this.items.filter((i) => !i.excluded).slice();
            }
            return;
        }
        // OPTION 2: applicable only for single per page selection
        // SOME ITEMS ARE SELECTED BUT NOT ON CURRENT DISPLAYED PAGE
        if (!withCtrlClick) {
            this.items.forEach((item) => {
                if (item._selected) {
                    temp.push(item.uuid);
                }
            });
            this.selectedItems = this.selectedItems.concat(
                this.items.filter((item) => temp.indexOf(item.uuid) < 0 && !item.excluded)
            );
            this.perPageSelected = this.perPageSelected.concat(
                this.items.filter((item) => temp.indexOf(item.uuid) < 0 && !item.excluded)
            );
        }
    }
    clearAllOnPage(withCtrlClick) {
        // CASE 1 (without CTRL click):
        // UNSELECT ALL ITEMS ON THE CURRENT PAGE
        if (!withCtrlClick || !this.allItems || !this.allItems.length) {
            let temp = [];
            this.items.forEach((item) => {
                if (item._selected && !item.excludedSelected) {
                    temp.push(item.uuid);
                    item._selected = !item._selected;
                }
            });
            if (this.multiSelect) {
                this.selectedItems = this.selectedItems.filter((item) => temp.indexOf(item.uuid) < 0);
                this.perPageSelected = this.perPageSelected.filter((item) => temp.indexOf(item.uuid) < 0);
            }
        }
        // CASE 2 (with CTRL click):
        // UNSELECT ALL AVAILABLE ITEMS ON ALL PAGES (number of items and pages depends weather some filters have been applied or not)
        else {
            let temp = [];
            this.allItems.forEach((item) => {
                if (!item.excludedSelected) {
                    temp.push(item.uuid);
                }
            });
            if (this.multiSelect) {
                this.selectedItems = [];
                this.perPageSelected = this.perPageSelected.filter(
                    (item) => temp.indexOf(item.uuid) < 0 && !item.isChild && !item.childJob
                );
            }
        }
    }
    clearAll() {
        this.selectedItems = this.selectedItems.filter((item) => !!item.excludedSelected);
        this.perPageSelected = this.perPageSelected.filter((item) => !!item.excludedSelected);
        if (this.onClearAll) {
            this.onClearAll();
        }
    }
    setSort(colKey, event) {
        const sortColumnHead = angular.element(event.target).closest('.table-head');
        const previousSortColumnHead = angular.element(`#${this.sortCol}-header`).closest('.table-head');
        const sortDesc = this.sortCol === colKey;
        if (!sortDesc) {
            previousSortColumnHead.removeClass('sort asc');
            previousSortColumnHead.addClass('sort desc');
        }
        this.sortCol = sortDesc ? `-${colKey}` : colKey;
        sortColumnHead.removeClass(`sort ${sortDesc ? 'asc' : 'desc'}`);
        sortColumnHead.addClass(`sort ${sortDesc ? 'desc' : 'asc'}`);
        this.orderBy = this.sortCol;
        this.onSort
            ? this.$timeout(() => this.onSort({ sortBy: (this.orderBy = this.sortCol) }), 0)
            : (this.items = sortDesc ? _.sortBy(this.items, colKey).reverse() : _.sortBy(this.items, colKey));
    }
    isCaretVisible(colKey) {
        return this.sortCol === `-${colKey}` || this.sortCol === colKey;
    }
    addColumn(column, index) {
        if (!index) this.columns.push(column);
        else this.columns.splice(index, 0, column);
        this.hasHeaderRow = this.columns.filter((c) => c.transclude.isSlotFilled('header')).length;
        this.hasFooterRow = this.columns.filter((c) => c.transclude.isSlotFilled('footer')).length;
    }
    addPreRow(preRow) {
        this.preRow = preRow;
    }
    addPostRow(postRow) {
        this.postRow = postRow;
    }
    beginEdit(item) {
        this.cancelEdit();
        const event = {
            item: item,
            editingItem: item,
            cancel: false,
        };
        this.onBeginEdit && this.onBeginEdit({ $event: event });
        if (event.cancel) {
            return false;
        }
        if (event.editingItem === item) {
            event.editingItem = angular.copy(item); // If event consumer didn't provide a clone, then we make our own
        }
        this.editInfo = {
            originalItem: item,
            editingItem: event.editingItem,
        };
        if (this.focusOnEdit) {
            const selectors = this.focusOnEdit.split(',');
            this.$timeout(() => {
                const elements = selectors.map((s) => this.$element.find(s).eq(0)).filter((e) => e.length);
                if (!elements.length) {
                    return;
                }
                elements[0].select();
                elements[0].focus();
            });
        }
        return true;
    }
    commitEdit() {
        if (!this.editInfo) {
            return false;
        }
        const event = {
            itemIndex: this.items.indexOf(this.editInfo.originalItem),
            originalItem: this.editInfo.originalItem,
            editingItem: this.editInfo.editingItem,
            handled: false,
            cancel: false,
        };
        event.doDefault = () => {
            this.items[event.itemIndex] = event.editingItem;
            event.handled = true;
        };
        this.onCommitEdit && this.onCommitEdit({ $event: event });
        if (event.cancel) {
            return false;
        }
        if (!event.handled) {
            event.doDefault();
        }
        delete this.editInfo;
        return true;
    }
    cancelEdit() {
        if (!this.editInfo) {
            return false;
        }
        this.onCancelEdit && this.onCancelEdit();
        delete this.editInfo;
        return true;
    }
    isEditing(item) {
        return (
            !!this.editInfo &&
            (arguments.length === 0 || this.editInfo.originalItem === item || this.editInfo.editingItem === item)
        );
    }
    scrollTo(event) {
        if (!event) {
            this.eventTargetEl = null;
            return;
        }
        this.eventTargetEl = $(event.target);
        this.$timeout(() => {
            this.scrollRowIntoView($(event.target), this.$element.find('tbody'));
        }, 0);
    }
    scrollRowIntoView(element, container, onUpdate) {
        element = element && element[0] && element[0].tagName.toUpperCase() !== 'TR' ? element.closest('tr') : element;
        if (!element || !element[0]) return;
        let containerHeight = container.height(),
            elementHeight = element.height(),
            containerTop = container.offset().top,
            elementTop = element.offset().top, // relative to the document.
            elementOffsetTop = element[0].offsetTop, // relative to the top of the offsetParent node
            elemOffsetBottom = elementOffsetTop + elementHeight,
            position;
        // ALREADY FULL VISIBLE
        if (elementTop > containerTop && elementTop + elementHeight < containerTop + containerHeight) {
            if (onUpdate) this.eventTargetEl = null;
            return;
        }
        // NOT VISIBLE ON BOTTOM or NOT VISIBLE ON TOP
        position = elementTop > containerTop ? elemOffsetBottom - containerHeight : elementOffsetTop;
        container.mCustomScrollbar('scrollTo', position, { timeout: 0 });
    }
    onScrollUpdate() {
        let ctrl = this;
        if (this.onCustomScrollUpdate) clearTimeout(this.onCustomScrollUpdate);
        this.onCustomScrollUpdate = setTimeout(
            function () {
                if (!ctrl.eventTargetEl) {
                    return;
                }
                ctrl.scrollRowIntoView(ctrl.eventTargetEl, ctrl.$element.find('tbody'), true);
            },
            !ctrl.eventTargetEl ? 0 : 200
        );
    }
    guid() {
        return (
            this.s4() +
            this.s4() +
            '-' +
            this.s4() +
            '-' +
            this.s4() +
            '-' +
            this.s4() +
            '-' +
            this.s4() +
            this.s4() +
            this.s4()
        );
    }
    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    getMultiSelectStyleFromGridStyleConfig(item) {
        if (angular.isUndefined(this.gridColumnsStyleConfig)) return;
        return this.gridColumnsStyleConfig.multiselect
            ? {
                  width: this.gridColumnsStyleConfig.columnsWidthMapInPct[0],
                  visibility: item && item.isHidden ? 'hidden' : 'visible',
              }
            : { width: '20px' };
    }
    getColumnStyleFromGridStyleConfig($index) {
        if (angular.isUndefined(this.gridColumnsStyleConfig)) return;
        return !this.gridColumnsStyleConfig.multiselect
            ? $index === 0
                ? { width: this.gridColumnsStyleConfig.columnsWidthMapInPct[0] }
                : { width: this.gridColumnsStyleConfig.columnsWidthMapInPct[$index] }
            : { width: this.gridColumnsStyleConfig.columnsWidthMapInPct[$index + 1] };
    }
    selectionStatus(items, selectedItems) {
        if (!items || items.length === 0 || !selectedItems || selectedItems.length === 0) {
            return 'none';
        }
        let i = 0;
        selectedItems.map((selected) =>
            items.map((item) => {
                if (selected.uuid === item.uuid) {
                    i++;
                }
            })
        );
        if (i === 0) {
            return 'none';
        }
        if (i === items.length) {
            return 'all';
        }
        return 'few';
    }
    // EXPECTED BEHAVIOUR:
    // Items that don't match searchBy and/or filterBy criteria won't be listed and should not be selected.
    // When criteria is removed, items that are visible again, should be selected.
    filterSelectedItems() {
        let currentSelected = [];
        let filteredSelected = [];
        let searchSelected = [],
            searchBy = this.searchBy,
            searchKey = this.searchKey,
            isSearchBySet = searchBy && searchKey,
            isSearchKeyArray = searchKey ? Array.isArray(searchKey) : null;
        // FOR EACH perPageSelected item we have to check:
        for (let i = 0; i < this.perPageSelected.length; i++) {
            let item = this.perPageSelected[i];
            // (1) IF SEARCH BY IS SET
            if (isSearchBySet) {
                if (this.doesItMatchSearchBy(item, searchBy, searchKey, isSearchKeyArray)) {
                    searchSelected.push(item);
                }
            }
            // (2) IF FILTER BY IS SET
            if (this.filters && this.filters.length) {
                if (this.doesItMatchFilterBy(item)) filteredSelected.push(item);
            }
        }
        // ONLY FILTER BY is set
        if (!searchBy || !searchKey) {
            currentSelected = filteredSelected;
        }
        // ONLY SEARCH BY is set
        else if (!this.filters || !this.filters.length) {
            currentSelected = searchSelected;
        }
        // BOTH SEARCH BY and FILTER BY are SET
        else {
            let filterSelectedUuid = filteredSelected.map((i) => i.uuid);
            searchSelected.forEach((item) => {
                if (filterSelectedUuid.indexOf(item.uuid) > -1) currentSelected.push(item);
            });
        }
        return currentSelected;
    }
    doesItMatchSearchBy(item, searchBy, searchKey, isSearchKeyArray) {
        let searchValueList = [];
        if (!isSearchKeyArray) {
            if (item[searchKey]) searchValueList.push(item[searchKey]);
        } else {
            searchKey.forEach((key) => {
                if (item[key]) searchValueList.push(item[key]);
            });
        }
        return searchValueList.toString().toLowerCase().indexOf(searchBy.toLowerCase()) > -1;
    }
    doesItMatchFilterBy(item) {
        let hasFilter,
            indexOfItem,
            filter,
            filterKey,
            filterBy,
            itemValue,
            itemValueList = [];
        for (let j = 0; j < this.filters.length; j++) {
            filter = this.filters[j];
            filterKey = filter.subSelection ? filter.subFilterKey : filter.filterKey;
            filterBy = filter.filterBy;
            if (!Array.isArray(filterKey)) {
                itemValue = item[filterKey];
                itemValueList = [itemValueList];
                if (filter.additionalSearch && filter.additionalSearch.length > 0) {
                    filter.additionalSearch.forEach((search) => itemValueList.push(item[search]));
                }
                if (filterBy && filterBy[0] && filterBy[0].subKey) {
                    // suBValue means that item has subKey property set, otherwise not
                    hasFilter = filterBy[0].subValue ? item[filterBy[0].subKey] : !item[filterBy[0].subKey];
                } else {
                    indexOfItem =
                        filter.type === 'search'
                            ? itemValueList.toString().toLowerCase().indexOf(filterBy.toLowerCase())
                            : itemValue
                            ? filterBy.toLowerCase().split('||').indexOf(itemValue.toLowerCase())
                            : -1;
                    if (indexOfItem === -1) {
                        hasFilter = false;
                        break;
                    } else {
                        hasFilter = true;
                    }
                }
            }
            // if filterKey is list, item stay selected only if each condition condition is met
            else {
                let noFind = false;
                let temp = filterBy.split('||');
                temp.forEach((t) => {
                    if (noFind) return;
                    let innerValue = filter.options.filter((i) => i.value === t)[0].innerValue;
                    let itemInnerValue = item[t];
                    itemInnerValue =
                        itemInnerValue !== undefined && itemInnerValue !== null
                            ? itemInnerValue.toString()
                            : itemInnerValue;
                    if (innerValue.toString() !== itemInnerValue) noFind = true;
                });
                if (noFind) {
                    hasFilter = false;
                    break;
                } else {
                    hasFilter = true;
                }
            }
        }
        return hasFilter;
    }
    onPreviewAction(index, item) {
        item._excludedPreview = !item._excludedPreview;
        this.selectedItems = [];
        this.perPageSelected = [];
        let otherPreviewItems = this.items.filter((i) => i._excludedPreview && i !== item);
        otherPreviewItems.forEach((op) => {
            op._excludedPreview = false;
        });
        if (this.onDetailsAction) {
            this.$timeout(() => {
                this.onDetailsAction({ index, item });
                this.scrollTo(event);
            }, 0);
        }
    }
}
GridController.$inject = dependencies;
var gridDirective = {
    restrict: 'E',
    scope: true,
    controller: GridController,
    controllerAs: 'grid',
    transclude: true,
    template: function (element, attr) {
        return attr.layout === 'table'
            ? require('./ctxGrid.table.template.html')
            : require('./ctxGrid.flex.template.html');
    },
    bindToController: {
        items: '<',
        allItems: '<?',
        reselectFlag: '<?',
        onInit: '&?',
        onClearAll: '&?',
        onBeginEdit: '&?',
        onCancelEdit: '&?',
        onCommitEdit: '&?',
        focusOnEdit: '@?',
        selectedItems: '=?',
        clickable: '@?',
        onSort: '&?',
        orderBy: '=?',
        searchBy: '=?',
        searchKey: '<?',
        disableSort: '<?',
        sortable: '@?',
        initialSortKey: '@?',
        idKey: '@?',
        multiSelect: '<?',
        multiSelectTooltip: '@?',
        multiSelectTooltipList: '<?',
        onDetailsAction: '&?',
        gridColumnsStyleConfig: '<?',
        multiSelectOnItem: '<?',
        skipPerPage: '<?',
        filters: '<?',
        autoChildSelection: '<?',
    },
};
module.exports = function () {
    return gridDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGrid.directive.js